export default __webpack_public_path__ + "static/media/Joloda.987f1601.png";